export function PlayIcon(props) {
  const style = {
    fill: "#eb2f06",
    ...props.style,
  };

  return (
    <svg
      width={props.size ? props.size : "1em"}
      height={props.size ? props.size : "1em"}
      version="1.1"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className="check"
    >
      <path
        d="M23.57,15.18l-13-9a1,1,0,0,0-1-.07A1,1,0,0,0,9,7V25a1,1,0,0,0,.54.89A1,1,0,0,0,10,26a1,1,0,0,0,.57-.18l13-9a1,1,0,0,0,0-1.64Z"
        style={style}
      ></path>
    </svg>
  );
}

export function PauseIcon(props) {
  const style = {
    fill: "#eb2f06",
    ...props.style,
  };

  return (
    <svg
      width={props.size ? props.size : "1em"}
      height={props.size ? props.size : "1em"}
      version="1.1"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className="check"
    >
      <rect
        x="7"
        y="6"
        width="6"
        height="20"
        rx="1"
        ry="1"
        style={style}
      ></rect>
      <rect
        x="19"
        y="6"
        width="6"
        height="20"
        rx="1"
        ry="1"
        style={style}
      ></rect>
    </svg>
  );
}

export function RewindIcon(props) {
  const style = {
    fill: "#eb2f06",
    ...props.style,
  };

  return (
    <svg
      width={props.size ? props.size : "1em"}
      height={props.size ? props.size : "1em"}
      version="1.1"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className="check"
    >
      <path
        d="M29.46,6.11a1,1,0,0,0-1,.07L17,14.09V7a1,1,0,0,0-.54-.89,1,1,0,0,0-1,.07l-13,9a1,1,0,0,0,0,1.64l13,9A1,1,0,0,0,16,26a1,1,0,0,0,.46-.11A1,1,0,0,0,17,25V17.91l11.43,7.91A1,1,0,0,0,29,26a1,1,0,0,0,.46-.11A1,1,0,0,0,30,25V7A1,1,0,0,0,29.46,6.11Z"
        style={style}
      ></path>
    </svg>
  );
}

export function ForwardIcon(props) {
  const style = {
    fill: "#eb2f06",
    ...props.style,
  };

  return (
    <svg
      width={props.size ? props.size : "1em"}
      height={props.size ? props.size : "1em"}
      version="1.1"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className="check"
    >
      <path
        d="M29.57,15.18l-13-9a1,1,0,0,0-1-.07A1,1,0,0,0,15,7v7.09L3.57,6.18a1,1,0,0,0-1-.07A1,1,0,0,0,2,7V25a1,1,0,0,0,.54.89A1,1,0,0,0,3,26a1,1,0,0,0,.57-.18L15,17.91V25a1,1,0,0,0,.54.89A1,1,0,0,0,16,26a1,1,0,0,0,.57-.18l13-9a1,1,0,0,0,0-1.64Z"
        style={style}
      ></path>
    </svg>
  );
}
